import { createFileRoute } from '@tanstack/react-router';
import { ApiSettings } from '../components/settings/ApiSettings';

export const Route = createFileRoute('/settings/api')({
  component: ApiSettings,
});
